import { createPaymentTokenSuccesful, createPaymentTokenFailed, paymentSuccessful, paymentFailed, paymentCancelled } from "../actions/payment/actionCreators";
import { createPaymentToken, createCardPayment, createGooglePayPaymentToken, createGooglePayPayment } from "../services/paymentService";
import { Dispatch } from "redux";

export function createPaymentTokenThunk (newCardDetails: NewCardDetails) {
    return async (dispatch: any) => {
        try {
            const res: PaymentTokenResponse = await createPaymentToken(newCardDetails)
            dispatch(createPaymentTokenSuccesful(res))
        } catch (err) {
            dispatch(createPaymentTokenFailed())
            console.log(err)
        }
    }
}

export function payWithVaultedCardThunk(customerId:string, cardTokenId:string, totalAmount:number) {
    return async (dispatch:Dispatch) => {
        try {
            const { requestReferenceNumber, cardPayment } = await createCardPayment(customerId,cardTokenId,totalAmount);
            processPaymentResult(cardPayment.status,requestReferenceNumber, dispatch);
        } catch (err) {
            console.log(err);
        }
    }
}

export function payWithGooglePayThunk(paymentData: google.payments.api.PaymentData, totalAmount: number) {
    return async (dispatch: Dispatch) => {
        try {
            const tokenRes = await createGooglePayPaymentToken(paymentData);
            dispatch(createPaymentTokenSuccesful(tokenRes));

            const { requestReferenceNumber, cardPayment } = await createGooglePayPayment(tokenRes.paymentTokenId, totalAmount, paymentData);
            if (cardPayment.verificationUrl) {
                window.location.href = cardPayment.verificationUrl;
            } else {
                processPaymentResult(cardPayment.status, requestReferenceNumber, dispatch);
            }
        } catch (err) {
            const payload: CreateCardPaymentPayload = {
                redirectPath: '/purchase/failed'
            };
            dispatch(paymentFailed(payload));
            console.log(err);
        }
    }
}

function processPaymentResult(result:string, requestReferenceNumber:string, dispatch:Dispatch) {
    const payload: CreateCardPaymentPayload = {
        redirectPath: ''
    }

    switch (result) {
        case 'PAYMENT_SUCCESS':
            payload.redirectPath = `/purchase/success/?id=${requestReferenceNumber}`
            dispatch(paymentSuccessful(payload));
            break;
        case 'PAYMENT_FAILED':
            payload.redirectPath = `/purchase/failed/?id=${requestReferenceNumber}`
            dispatch(paymentFailed(payload));
            break;
        case 'PAYMENT_CANCELLED':
            payload.redirectPath =`/purchase/canceled/?id=${requestReferenceNumber}`
            dispatch(paymentCancelled(payload));
            break;
        default:
            break;
    }
}
